module.exports = __webpack_public_path__ + "img/positive-impact.fb91c91e.svg";